import { registerAppLinks } from "@shared/services/appLinkRegistry";
import {
  whArticlesMultiple,
  whArticlesSingle,
  whSingleArticles,
} from "./constants";

registerAppLinks([
  {
    uriExpression: "twin-edit." + whArticlesSingle,
    routeName: "warehouseEditSingle",
  },
  {
    uriExpression: "twin-edit." + whArticlesMultiple,
    routeName: "warehouseEditMultiple",
  },
  {
    uriExpression: "twin-edit." + whSingleArticles,
    routeName: "warehouseEditSingleArticle",
  },
]);
